import httpClient from "./httpClient";

const entityEndpoint = "/discount_codes";

export default {
  /**
   * Discount Codes
   */
  async getDiscountCodes(params) {
    const response = await httpClient.get(entityEndpoint, { params });
    return response.data;
  },

  async getDiscountCode(id) {
    const response = await httpClient.get(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async getDiscountBookings(discountId) {
    const response = await httpClient.get(`${entityEndpoint}/${discountId}`);
    return response.data;
  },

  async createDiscountCode(discountCode) {
    const response = await httpClient.post(entityEndpoint, {
      ...discountCode
    });
    return response.data;
  },

  async updateDiscountCode(discountCode) {
    const response = await httpClient.put(
      `${entityEndpoint}/${discountCode.id}`,
      { ...discountCode }
    );
    return response.data;
  },

  async deleteDiscountCode(discountCode) {
    const response = await httpClient.delete(
      `${entityEndpoint}/${discountCode.id}`
    );
    return response.data;
  },

  async getAvailableDiscounts(booking) {
    const response = await httpClient.get(
      `/bookings/${booking.id}/available-discounts`
    );
    return response.data;
  },

  /**
   * Discount Rulesets
   */
  async addRuleSet(args) {
    const response = await httpClient.post(
      `${entityEndpoint}/${args.discountCode.id}/rulesets`,
      {
        ...args.ruleset
      }
    );
    return response.data;
  },

  async updateRuleSet(args) {
    const response = await httpClient.put(
      `${entityEndpoint}/${args.discountCode.id}/rulesets/${args.ruleset.id}`,
      {
        ...args.ruleset
      }
    );
    return response.data;
  },

  async removeRuleSet(args) {
    const response = await httpClient.delete(
      `${entityEndpoint}/${args.discountCode.id}/rulesets/${args.ruleset.id}`
    );
    return response.data;
  }
};
